import React,{useState,useEffect} from 'react'
import SubHeader from '../../layout/components/SubHeader'
import { KTSVG } from '../../helpers/KTSVG'
import { Tooltip } from 'react-tooltip'
import clsx from 'clsx'
import Flatpickr from 'react-flatpickr'
import { useNavigate } from 'react-router-dom'
function ActivityHeader({activityType,activityDate}) {
    const [sortStatus, setSortStatus] = useState("unsorted");
    const [data,setDate] = useState(activityDate)
   // const onChange = date => setDate(date)
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate()); // Get tomorrow's date
    const navigate = useNavigate()
  const onChange = date => {
    //change date in Y-m-d format
    const dateString = date[0].toISOString().split('T')[0];
    console.log(dateString);
    setDate(dateString)
    navigate(`/activity/${activityType}/${dateString}`)
  }
  useEffect(()=>{
    setDate(activityDate)
    console.log(activityDate)
  },[activityDate])
  return (
    <>
    <SubHeader title="My Activity" description={"Regular Activities on the platform"}>
        <div className="d-flex flex-row justify-content-end align-items-center mt-3">
          {data &&
        <Flatpickr
            value = {data}
            options={{
             
              dateFormat: "Y-m-d",
            }}
             onChange={onChange}
            className='form-control'
        />}
        <button
            data-tooltip-id="tt_options"
            data-tooltip-place="bottom-start"
            className="btn btn-outline btn-sm btn-icon-info ms-3 mb-2"
          >
            <KTSVG
              path="media/icons/duotune/general/gen053.svg"
              className="svg-icon-1"
            />
          </button>
          <Tooltip
            id="tt_options"
            clickable
            className="bg-secondary"
            style={{ zIndex: "107" }}
          >
            <div className="d-flex flex-column">
              <span className="text-gray-800">Sort by name</span>
              <button
                className={clsx("btn", "btn-sm", "mb-2", "btn-secondary", {
                  active: sortStatus === "ascending",
                })}
               
              >
                <i className="bi bi-sort-alpha-down fs-4"> </i> Ascending
              </button>
              <button
                className={clsx("btn", "btn-sm", "mb-2", "btn-secondary", {
                  active: sortStatus === "descending",
                })}
               
              >
                <i className="bi bi-sort-alpha-up fs-4"> </i> Descending
              </button>
              <span className="text-gray-800">Sort by date</span>
              <button
                className={clsx("btn", "btn-sm", "mb-2", "btn-secondary", {
                  active: sortStatus === "latest",
                })}
              
              >
                <i className="bi bi-arrow-down fs-4"> </i> Latest
              </button>
              <button
                className={clsx("btn", "btn-sm", "mb-2", "btn-secondary", {
                  active: sortStatus === "oldest",
                })}
               
              >
                <i className="bi bi-arrow-up fs-4"> </i> Oldest
              </button>
            </div>
       
        </Tooltip>
        </div>
    </SubHeader>
    </>
  )
}

export default ActivityHeader